window.ListarConhecimentoTransporteController = ControllerBase.extend({
    name: 'ListarConhecimentoTransporteController',
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Filial', prop: 'Filial' },
            { title: 'Nº Orçamento', prop: 'NumeroPedido' },
            { title: 'Cliente', prop: 'RazaoSocialCliente' },
            { title: 'Vendedor', prop: 'Vendedor' },
            { title: 'Data', prop: 'DataPedido', type: 'Date' },
            { title: 'Valor', prop: 'ValorPedido', type: 'Money' }
        ],
        getData: function () {
            return ko.mapping.toJS(this.orcamento);
        },
    }),

    ajax: function () {
        return {
            url: '/ConhecimentoTransporte/_ConhecimentoTransporte',
            type: 'post',
            data: {
                numeroPedido: this.orcamento.NumeroPedido()
            }
        };
    }
})